import { getApiUrl } from "@commons-monorepo/index";
import { FakeAdsProductsResponse } from "../entities/user-statistics.response";

export const fetchUserStatistics = async (
  token: string,
): Promise<FakeAdsProductsResponse> => {
  try {
    const response = await fetch(
      `${getApiUrl()}/api/ms/growth/fake-ads/products`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        } as HeadersInit,
      },
    );
    return response.status === 200
      ? ((await response.json()) as FakeAdsProductsResponse)
      : [];
  } catch (error) {
    return [];
  }
};
